import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

const isTokenValid = (token) => {
  try {
    const decoded = jwtDecode(token);
    // التأكد من أن التوكن لم ينتهِ صلاحيته
    if (decoded.exp * 1000 < Date.now()) {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
};

const ProtectedRoute = ({ children }) => {
  const token = Cookies.get("token");

  // التحقق من وجود التوكن وصلاحيته
  if (!token || !isTokenValid(token)) {
    return <Navigate to="/login" replace />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
